export function resourceInitiatorTypeIs(value, types) {
    return types.some((type) => type === value);
}
//# sourceMappingURL=instrumentation.helper.js.map